
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsTaxInvoiceDtGrid extends Serenity.EntityGrid<PsTaxInvoiceDtRow, any> {
        protected getColumnsKey() { return PsTaxInvoiceDtColumns.columnsKey; }
        protected getDialogType() { return PsTaxInvoiceDtDialog; }
        protected getIdProperty() { return PsTaxInvoiceDtRow.idProperty; }
        protected getInsertPermission() { return PsTaxInvoiceDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsTaxInvoiceDtRow.localTextPrefix; }
        protected getService() { return PsTaxInvoiceDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        
    }
}